import { FC } from 'react';
import { Avatar, Icon, Text, Flex } from '@/_components';
import { OwnerAvatarProps } from './OwnerAvatar.types';
import styles from './OwnerAvatar.module.css';
import { getClasses } from '@/_utils/classnames';

export const OwnerAvatar: FC<OwnerAvatarProps> = ({
  isAdding,
  isRemoving,
  name,
}) => {
  const iconClasses: string = getClasses(styles.ownerAvatar__icon, {
    [styles.ownerAvatar__iconAdding]: isAdding,
    [styles.ownerAvatar__iconRemoving]: isRemoving,
  });
  return (
    <Flex isYCentered={true} gap={2}>
      {isAdding || isRemoving ? (
        <Flex isCentered={true} className={iconClasses}>
          <Icon name={isRemoving ? 'minus' : 'plus'} size={16} />
        </Flex>
      ) : (
        <Avatar name={name} size={32} type="user" />
      )}
      <Text
        fontWeight="medium"
        type="small"
        color={isAdding ? 'accent' : isRemoving ? 'caution' : undefined}
      >
        {name}
      </Text>
    </Flex>
  );
};
